import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { CompanyListProvider, EnvironmentListProvider, StructureTotemEditProvider, StructureTotemListProvider } from 'cw-backend';
import { MomentModule } from 'ngx-moment';
import { ListPasswordsComponent } from './components/list-passwords/list-passwords.component';
import { TotemNotifyComponent } from './components/totem-notify/totem-notify.component';
import { TotemControlComponent } from './totem-control.component';

@NgModule({
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSortModule,
    MatSnackBarModule,
    MatTableModule,
    MatDialogModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatListModule,
    MatDatepickerModule,
    MatTabsModule,
    MatToolbarModule,
    MatMenuModule,
    MomentModule,
    MatBadgeModule,
    MatCardModule,
    MatSlideToggleModule,
    FuseSharedModule,
    MatButtonToggleModule
  ],
  declarations: [TotemControlComponent, TotemNotifyComponent, ListPasswordsComponent],
  exports: [TotemControlComponent, TotemNotifyComponent],
  providers: [StructureTotemListProvider, EnvironmentListProvider, CompanyListProvider, StructureTotemEditProvider]
})
export class TotemControlModule { }
